import { render } from "./CurrencyIcon.vue?vue&type=template&id=22b03412&scoped=true"
import script from "./CurrencyIcon.vue?vue&type=script&lang=js"
export * from "./CurrencyIcon.vue?vue&type=script&lang=js"

import "./CurrencyIcon.vue?vue&type=style&index=0&id=22b03412&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b03412"]])

export default __exports__